var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [
    _c("nav", { staticClass: "navbar is-primary" }, [
      _c(
        "div",
        { staticClass: "navbar-brand" },
        [
          _c(
            "router-link",
            { staticClass: "navbar-item", attrs: { to: "/" } },
            [_vm._v("\n        " + _vm._s(_vm.DefaulTitle) + "\n      ")]
          )
        ],
        1
      ),
      _c("div", { staticClass: "navbar-menu is-active" }, [
        _c("div", { staticClass: "navbar-end" }, [
          _c(
            "button",
            {
              staticClass: "flag-btn",
              attrs: { title: "Français", "aria-label": "Français" },
              on: {
                click: function($event) {
                  return _vm.changeLocale("fr")
                }
              }
            },
            [_c("country-flag", { attrs: { country: "fr" } })],
            1
          ),
          _c(
            "button",
            {
              staticClass: "flag-btn",
              attrs: { title: "English", "aria-label": "English" },
              on: {
                click: function($event) {
                  return _vm.changeLocale("en")
                }
              }
            },
            [_c("country-flag", { attrs: { country: "gb" } })],
            1
          ),
          _vm.user
            ? _c(
                "div",
                { staticClass: "navbar-item has-dropdown is-hoverable" },
                [
                  _c("div", { staticClass: "navbar-link" }, [
                    _vm._v(
                      "\n            " + _vm._s(_vm.user.name) + "\n          "
                    )
                  ]),
                  _c("div", { staticClass: "navbar-dropdown is-right" }, [
                    _c(
                      "a",
                      {
                        staticClass: "navbar-item",
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.logout($event)
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("default.logout")) + " ")]
                    ),
                    _c(
                      "a",
                      {
                        staticClass: "navbar-item",
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.downloadUserGuide($event)
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("default.userguide")) + " ")]
                    )
                  ])
                ]
              )
            : _vm._e()
        ])
      ])
    ]),
    _c("div", { staticClass: "main" }, [_c("router-view")], 1)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }